import React from "react"
import CloseIcon from "@/public/icons/close.svg"
import PDPTrimCalculator from "@/components/cart/RecalculateModal/TrimCalculator"
const RecalculateModal = props => {
  const isShow = props.isShow
  const i18n = props.i18n
  const showHideClass = isShow ? "modal-display-block" : "modal-display-none"
  const { allAdditinalInfo: { discountPrice = "", price = "" } = {} } =
    props ?? {}
  return (
    <div className={`cart-landing-recalculate__modal-popup ${showHideClass}`}>
      <div className="cart-landing-recalculate">
        <div className="cart-landing-recalculate__container">
          <div className="cart-landing-recalculate__tile-calculator">
            <img
              src={CloseIcon?.src}
              alt=""
              onClick={props.onClose}
              className="cart-landing-recalculate__tile-calculator__closeImg"
            />
            <PDPTrimCalculator
              shwoInModal="yes"
              totalNeeded={props.allAdditinalInfo.totalNeeded}
              totalArea={props.allAdditinalInfo.totalArea}
              overage={props.allAdditinalInfo.overage}
              soldByBox={props.allAdditinalInfo.soldByBox}
              soldByUom={props.allAdditinalInfo.soldByUom}
              priceByBox={props.allAdditinalInfo.price}
              templateType={props.allAdditinalInfo.templateType}
              staticTexts={props.i18n}
              discountPrice={props.allAdditinalInfo.discountPrice}
              totalPrice={props.allAdditinalInfo.totalPrice}
              totalBoxes={props.allAdditinalInfo.totalBoxes}
              productInfo={props?.productInfo}
              updateRecalculateCarts={props.updateRecalculateCarts}
              i18n={i18n}
              totalSFNeeded={props?.allAdditinalInfo?.totalSFNeeded}
              {...props}
            />
          </div>
        </div>
        <div className="cart-landing-recalculate__footer">
          <div className="cart-landing-recalculate__footer__body">
            <img
              src={props.allAdditinalInfo ? props.allAdditinalInfo.image : ""}
              alt=""
            ></img>
            <div className="cart-landing-recalculate__footer__contents">
              <div className="title">
                {props.allAdditinalInfo ? props.allAdditinalInfo.name : ""}
              </div>
            </div>
            <div className="cart-landing-recalculate__footer__price-details">
              <span className="price">
                {props.allAdditinalInfo
                  ? props.allAdditinalInfo.currencySign
                  : ""}
                {Number(discountPrice) ? discountPrice : price}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default RecalculateModal
